import InsertSortBisBox from "../../../../src/content/articles/medianofmedian/InsertSortBis.js";
import QuickSortBisBox from "../../../../src/content/articles/medianofmedian/QuickSortBis.js";
import MomBox from "../../../../src/content/articles/medianofmedian/Mom.js";
import React from 'react';
export default {
  InsertSortBisBox,
  QuickSortBisBox,
  MomBox,
  React
};